import React, { Component, Fragment } from 'react';
import { Redirect, Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { TopMenu } from '../TopMenu/TopMenu';
import { NavMenu } from '../NavMenu/NavMenu';
import authService from '../../services/AuthService';
import CadeInputComponent from './CadeInputComponent';
import CadeAnalyzeComponent from './CadeAnalyzeComponent';
import CadeReportDomainComponent from './CadeReportDomainComponent';
import CadeInputAssessmentComponent from './CadeInputAssessmentComponent';
import CadeReportAssessmentComponent from './CadeReportAssessmentComponent';
import CadeAnalyzeAssessmentComponent from './CadeAnalyzeAssessmentComponent';
import CadePartnerAnalyzeAssessmentComponent from './CadePartnerAnalyzeAssessmentComponent';
import CadeMonitorAssessmentComponent from './CadeMonitorAssessmentComponent';
import CadeMonitorDomainComponent from './CadeMonitorDomainComponent';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';
import api, { apiErrorHandler } from '../../services/AxiosService';

import cadeLogo from '../../content/CADEAIHeader.png';
import { apiErrorPopup } from '../../helpers/MessagePopup';

/*
 * CadeComponent is the superclass of the instantiated CADE related components.  It is responsible for managing the Mode and Domain selections and instantiating the proper CADE component.
 */

class CadeComponent extends Component {
    constructor(props) {
        super(props);

        let initialDomain = "Communicating";

        if (authService.authenticatedUserRestrictedDomains != null) {

            initialDomain = authService.authenticatedUserRestrictedDomains.split(",")[0];
        }

        this.state = {
            // Initial state when first entering is Input/Understanding
            cadeMode: 'Input',
            cadeModeFor: authService.userType,
            cadeDomain: initialDomain,
            domainDisplayName: initialDomain,
            selectedIndex: props.selectedIndex,
            personFirstName: props.personFirstName,
            personLastName: props.personLastName,
            personBirthDate: props.personBirthDate,
            personAge: props.personAge,
            providerId: props.providerId,
            assessmentId: props.assessmentId,
            assessmentDate: props.assessmentDate,
            compareAssessmentId: (props.compareAssessmentId === 0) ? props.assessmentId : props.compareAssessmentId,     // Not used for progress monitoring, just comparing 2 assessments
            compareAssessmentDate: (isNullOrEmpty(props.compareAssessmentDate)) ? props.assessmentDate : props.compareAssessmentDate,
            personAssessments: props.personAssessments,
            navMarkers: null,
            resetExtraButtonsToMe: false, 
        }
    }

    // Handle date compare selections
    compareSelectionHandler = (compareAssessmentId, compareAssessmentDate) => {
        this.setState({ compareAssessmentId: compareAssessmentId, compareAssessmentDate: compareAssessmentDate });
    }

    // Handle Mode selection by setting the state.  This will re-render from here down.
    modeSelectionHandler = (selectedMode, forUserType) => {
        if (forUserType === 0) {
            // This is the "me" case.  Set the user type based upon the logged in user
            forUserType = authService.userType;
        }

        if (this.state.cadeMode != selectedMode) {
            this.setState({ cadeMode: selectedMode, resetExtraButtonsToMe: true});
            this.getNavMarkers(selectedMode, forUserType);
        }
        else if (this.state.cadeModeFor != forUserType) {
            this.setState({ cadeModeFor: forUserType, resetExtraButtonsToMe: false });
            this.getNavMarkers(selectedMode, forUserType);
        }
    };
    
    // Handle Domain selection by setting the state.  This will trigger a re-render
    domainSelectionHandler = (selectedDomain) => {
        // selected domain = internal domain name.display name
        let domainNames = selectedDomain.split(".");
        if (this.state.cadeDomain != selectedDomain) {
            this.setState({ cadeDomain: domainNames[0], domainDisplayName: domainNames[1] });
        }
    };

    navUpdateReportHandler = (newIcon) => {
        // This handles turning a report domain on/off and thus setting the appropriate icon
        let newNavMarkers = new Map();
        let cadeDomain = this.state.cadeDomain;
        this.state.navMarkers.forEach(function (value, key) {
            if (key != cadeDomain) {
                newNavMarkers.set(key, value);
            }
            else {
                newNavMarkers.set(key, { source: newIcon, type: "image" });
            }
        });

        this.setState({ navMarkers: newNavMarkers });
    }

    navUpdateHandler = (newValue) => {
        if (isNullOrEmpty(this.state.cadeDomain)) {
            return;
        }

        // This handles inputs to updates and updating the nav markers
        let newNavMarkers = new Map();
        let newSource = 0;
        let cadeDomain = this.state.cadeDomain;
        this.state.navMarkers.forEach(function (value, key) {
            if (key != cadeDomain) {
                newNavMarkers.set(key, value);
            }
            else {
                newSource = (newValue == "") ? parseInt(value.source, 10) + 1 : parseInt(value.source, 10) - 1;
                if (newSource < 0) {
                    newSource = 0;
                }
                newNavMarkers.set(key, { source: newSource, type: "text" });
            }
        });

        // This is a temporary update and may not be completely accurate.  Each save will get a new, accurate count.
        this.setState({ navMarkers: newNavMarkers });
    }

    navMarkersHandler = (newMarkers) => {
        this.setState({ navMarkers: newMarkers });
    }

    getNavMarkers = (mode, forUserType) => {
        /*
       * Run a query to get the navMarkers for all domains in the given mode 
       */
        if (isNullOrEmpty(this.state.assessmentId) || this.state.assessmentId == 0) {
            return;
        }

        let cadeMode = (mode === null) ? this.state.cadeMode : mode;

        let userType = forUserType;
        // URL of the form:  "{id:int}/uid/{uId:int}/prvid/{prvId}/monitor/{ut:int}/navmarkers"
        let url = "assessment/" + this.state.assessmentId + "/uid/" + authService.authenticatedUserId + "/prvid/"  + this.state.providerId + "/" + cadeMode + "/" + userType + "/navmarkers";
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
            .then((response) => {
                if (response.status == 200) {
                    // Add the navMarker definition to state
                    let markerMap = new Map();
                    for (let i = 0; i < response.data.length; i++) {
                        markerMap.set(response.data[i].domainName, response.data[i].navMarker);
                    }
                    this.setState({ navMarkers: markerMap });
                }
            })
            .catch(error => {
                // Major problem - should not happen. 
                apiErrorPopup(apiErrorHandler(error));
            });
    }

    numUnanswered = () => {
        if (this.state.navMarkers == null) {
            return 80;
        }

        let numUnanswered = 0;
        this.state.navMarkers.forEach(function (value, key) {
            numUnanswered += parseInt(value.source, 10);
        });
        return numUnanswered;
    }

    componentDidMount = () => {
        this.getNavMarkers(this.state.cadeMode, this.state.cadeModeFor);
    }

    nextDomain = () => {
        let nextDomain = null;
        let displayName = null;

        switch (this.state.cadeDomain) {
            case "Communicating":
                nextDomain = "Socializing";
                break;

            case "Socializing":
                nextDomain = "DailyLiving";
                displayName = "Daily Living";
                break;

            case "DailyLiving":
                nextDomain = "MovingSensing";
                displayName = "Moving & Sensing";
                break;

            case "MovingSensing":
                nextDomain = "Understanding";
                break;

            case "Understanding":
                nextDomain = "Learning";
                break;

            case "Learning":
                nextDomain = "Focusing";
                break;

            case "Focusing":
                nextDomain = "Organizing";
                break;

            case "Organizing":
                nextDomain = "Remembering";
                break;

            case "Remembering":
                nextDomain = "Feeling";
                break;

            case "Feeling":
                nextDomain = "Behaving";
                break;

            default:
                break;
        }
        if (nextDomain == null) {
            return;
        }
        if (displayName == null) {
            displayName = nextDomain;
        }
        this.setState({ cadeDomain: nextDomain, domainDisplayName: displayName });
        return;
    }

    prevDomain = () => {
        let prevDomain = null;
        let displayName = null;
        switch (this.state.cadeDomain) {
            
            case "Socializing":
                prevDomain = "Communicating";
                break;

            case "DailyLiving":
                prevDomain = "Socializing";
                break;

            case "MovingSensing":
                prevDomain = "DailyLiving";
                displayName = "Daily Living";
                break;

            case "Understanding":
                prevDomain = "MovingSensing";
                displayName = "Moving & Sensing";
                break;

            case "Learning":
                prevDomain = "Understanding";
                break;

            case "Focusing":
                prevDomain = "Learning";
                break;

            case "Organizing":
                prevDomain = "Focusing";
                break;

            case "Remembering":
                prevDomain = "Organizing";
                break;

            case "Feeling":
                prevDomain = "Remembering";
                break;

            case "Behaving":
                prevDomain = "Feeling";
                break;

            default:
                break;
        }
        if (prevDomain == null) {
            return;
        }
        if (displayName == null) {
            displayName = prevDomain;
        }
        this.setState({ cadeDomain: prevDomain, domainDisplayName: displayName });
        return;
    }

    setCadeDomain = (domain) => {
        this.setState({ cadeDomain: domain });
    }

    render() {
        // Make sure users are authenticated to use this page.  Otherwise, boot them to login
        if (!authService.isAuthenticated) {
            return ( <Redirect to='/' /> );
        }

        if (this.props.assessmentId == 0) {
            return ( <Redirect to='/home' />)
        }

        // Each cade Mode page has a similar layout with different content.  Instantiate each differently
        // Note!!! the key attribute in the components below.  Without it, react will reuse the existing component (and it's constructor will not be called).  Unique key values for a new component instance.
        let cadeComponent = null;
        switch (this.state.cadeMode) {
            case 'Input':
                if (this.state.cadeDomain == "CadeAssessment" || this.state.cadeDomain == "CadePartnerAssessment") {
                    cadeComponent = <CadeInputAssessmentComponent
                        assessmentId={this.props.assessmentId}
                    />
                }
                else {
                    cadeComponent = <CadeInputComponent
                        cadeMode={this.state.cadeMode}
                        cadeDomain={this.state.cadeDomain}
                        domainDisplayName={this.state.domainDisplayName}
                        assessmentId={this.props.assessmentId}
                        selectedIndex={this.state.selectedIndex}
                        navUpdateHandler={this.navUpdateHandler}
                        navMarkersHandler={this.navMarkersHandler}
                        personFirstName={this.state.personFirstName}
                        personLastName={this.state.personLastName}
                        nextDomain={this.nextDomain}
                        prevDomain={this.prevDomain}
                        numUnanswered={this.numUnanswered}
                        key={this.state.cadeMode + this.state.cadeModeFor + this.state.cadeDomain + this.props.assessmentId}
                    />
                }
                break;

            case 'Analyze':
                switch (this.state.cadeDomain) {
                    case "CadeAssessment":
                        cadeComponent = <CadeAnalyzeAssessmentComponent
                            assessmentId={this.props.assessmentId}
                            cadeMode={this.state.cadeMode}
                            cadeModeFor={this.state.cadeModeFor}
                            cadeDomain={this.state.cadeDomain}
                            personAge={this.state.personAge}
                            key={this.state.cadeMode + this.state.cadeModeFor + this.state.cadeDomain + this.props.assessmentId}
                        />
                        break;

                    case "CadePartnerAssessment":
                        cadeComponent = <CadePartnerAnalyzeAssessmentComponent
                            assessmentId={this.props.assessmentId}
                            cadeMode={this.state.cadeMode}
                            cadeModeFor={this.state.cadeModeFor}
                            cadeDomain={this.state.cadeDomain}
                            personAge={this.state.personAge}
                            key={this.state.cadeMode + this.state.cadeModeFor + this.state.cadeDomain + this.props.assessmentId}
                        />
                        break;

                    default:
                        cadeComponent = <CadeAnalyzeComponent
                            cadeMode={this.state.cadeMode}
                            cadeModeFor={this.state.cadeModeFor}
                            cadeDomain={this.state.cadeDomain}
                            domainDisplayName={this.state.domainDisplayName}
                            assessmentId={this.props.assessmentId}
                            selectedIndex={this.state.selectedIndex}
                            personFirstName={this.state.personFirstName}
                            personLastName={this.state.personLastName}
                            personAge={this.state.personAge}
                            key={this.state.cadeMode + this.state.cadeModeFor + this.state.cadeDomain + this.props.assessmentId}
                        />
                        break;
                }
                break;

            case 'Monitor':
                switch (this.state.cadeDomain) {
                    case "CadeAssessment":
                    case "CadePartnerAssessment":
                        cadeComponent = <CadeMonitorAssessmentComponent
                            assessmentId={this.props.assessmentId}
                            providerId={this.props.providerId}
                            assessmentDate={this.state.assessmentDate}
                            cadeMode={this.state.cadeMode}
                            cadeModeFor={this.state.cadeModeFor}
                            cadeDomain={this.state.cadeDomain}
                            domainDisplayName={this.state.domainDisplayName}
                            domainImage={"CadeAssessment"}
                            key={this.state.cadeMode + this.state.cadeModeFor + this.state.cadeDomain + this.state.assessmentId}
                        />
                        break;

                    default:
                        cadeComponent = <CadeMonitorDomainComponent
                            assessmentId={this.props.assessmentId}
                            providerId={this.props.providerId}
                            assessmentDate={this.state.assessmentDate}
                            cadeMode={this.state.cadeMode}
                            cadeModeFor={this.state.cadeModeFor}
                            cadeDomain={this.state.cadeDomain}
                            domainDisplayName={this.state.domainDisplayName}
                            key={this.state.cadeMode + this.state.cadeModeFor + this.state.cadeDomain + this.state.assessmentId}
                        />
                        break;
                }
                break;

            case 'Report':
                if (this.state.cadeDomain == "CadeAssessment" || this.state.cadeDomain == "CadePartnerAssessment") {
                    cadeComponent = <CadeReportAssessmentComponent
                        assessmentId={this.props.assessmentId}
                        assessmentDate={this.props.assessmentDate}
                        providerId={this.state.providerId}
                        cadeMode={this.state.cadeMode}
                        cadeModeFor={this.state.cadeModeFor}
                        cadeDomain={this.state.cadeDomain}
                        domainDisplayName={this.state.domainDisplayName}
                        personFirstName={this.state.personFirstName}
                        personLastName={this.state.personLastName}
                        personBirthDate={this.state.personBirthDate}
                        personAge={this.state.personAge}
                        clinicianFirstName={authService.authenticatedUserFirstName}
                        clinicianLastName={authService.authenticatedUserLastName}
                        clinicianDegrees={authService.authenticatedUserDegrees}
                        key={new Date().getTime()}
                    />
                }
                else {
                    cadeComponent = <CadeReportDomainComponent
                        cadeMode={this.state.cadeMode}
                        cadeModeFor={this.state.cadeModeFor}
                        cadeDomain={this.state.cadeDomain}
                        domainDisplayName={this.state.domainDisplayName}
                        assessmentId={this.props.assessmentId}
                        assessmentDate={this.props.assessmentDate}
                        selectedIndex={this.state.selectedIndex}
                        personFirstName={this.state.personFirstName}
                        personLastName={this.state.personLastName}
                        personBirthDate={this.state.personBirthDate}
                        personAge={this.state.personAge}
                        navUpdateReportHandler={this.navUpdateReportHandler}
                        domainChangeHandler={this.setCadeDomain}
                        key={this.state.cadeMode + this.state.cadeDomain + this.props.assessmentId}
                    />
                }
                break;

            default:
                // Should never get here
                break;
        }

        let navKey = this.state.cadeDomain + this.state.cadeMode + this.state.cadeModeFor;

        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col sm={3}>
                            {!authService.isRaterOrCaregiver &&
                                <Link to={'/home'}><img className='cadeComponent_cadeLogo tour_cadeLogo' align='middle' src={cadeLogo} title='CADE Home' alt='CADE logo' /></Link>
                            }
                            {authService.isRaterOrCaregiver &&
                                <img className='cadeComponent_cadeLogo tour_cadeLogo' align='middle' src={cadeLogo} title='CADE Home' alt='CADE logo' />
                            }
                        </Col>
                        <Col sm={9}>
                            <TopMenu
                                tourId="tour_modeNavigation"
                                cadeMode={this.state.cadeMode}
                                cadeModeFor={this.state.cadeModeFor}
                                selectionHandler={this.modeSelectionHandler}
                                resetToMe={this.state.resetExtraButtonsToMe}
                            />
                        </Col>
                    </Row>
                    <Row className="my-other-step">
                        <Col sm={3}>
                            <NavMenu
                                tourId="tour_domainNavigation"
                                assessmentId={this.state.assessmentId}
                                cadeMode={this.state.cadeMode}
                                cadeModeFor={this.state.cadeModeFor}
                                cadeDomain={this.state.cadeDomain}
                                selectionHandler={this.domainSelectionHandler}
                                navMarkers={this.state.navMarkers}
                                personFirstName={this.state.personFirstName}
                                personLastName={this.state.personLastName}
                                assessmentDate={this.state.assessmentDate}
                                key={navKey + this.state.navMarkers}
                        />
                        </Col>
                        <Col sm={9}>
                            {cadeComponent}
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        );
    }
} 

export default CadeComponent;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeComponent.js